import { ButtonAdd } from '@seiue/ui'
import { Tag } from 'antd'
import { useAtomValue } from 'jotai'
import { useContext } from 'react'
import styled, { css } from 'styled-components'

import { QuestionTypeEnum } from 'packages/sdks-next/growp'
import { getLetterByIndex } from 'packages/utils'

import { WaringText } from '@/components/Styled'
import { EditPaperContext } from '@/features/test-paper/pages/EditPaper/context'

import { isValidQuestionFieldAtom } from '../../atom'

import { EditAnswerComponent } from './index'

/**
 * 编辑答案组件
 *
 * @param param0 - Argument Object
 * @param param0.answers - 答案
 * @param param0.onEditAnswer - 编辑答案
 * @param param0.type - 题型
 * @returns 组件
 */
export const EditChoiceAnswer: EditAnswerComponent = ({
  answers,
  onEditAnswer,
  type,
}) => {
  const { limitLevel } = useContext(EditPaperContext)
  const { options, standardAnswers } = answers || {}
  const isValidField = useAtomValue(isValidQuestionFieldAtom)

  const hasOptions = options?.length > 0
  const isSingleChoice = type === QuestionTypeEnum.SingleChoice
  const noAnswers = standardAnswers?.length === 0

  const rules = [
    { rule: !hasOptions, message: '点击添加选项' },
    {
      rule: hasOptions && noAnswers && isValidField,
      message: '点击选择正确答案',
    },
    {
      rule:
        hasOptions &&
        !isSingleChoice &&
        isValidField &&
        !noAnswers &&
        standardAnswers.length < 2,
      message: '多选题至少选择两个答案',
    },
  ]

  return (
    <Wrapper>
      <ChoiceAnswerWrapper>
        {options?.map((a, index) => (
          <StyleTag
            $isStandardAnswer={!!standardAnswers?.includes(a)}
            closable={limitLevel > 0 ? false : options?.length === index + 1}
            key={a}
            onClick={() => {
              if (limitLevel > 0) return
              const resStandardAnswers = [...(standardAnswers || [])]
              if (type === QuestionTypeEnum.SingleChoice) {
                onEditAnswer({ standardAnswers: [a] })
              } else {
                if (resStandardAnswers.includes(a)) {
                  resStandardAnswers.splice(resStandardAnswers.indexOf(a), 1)
                } else {
                  resStandardAnswers.push(a)
                }
                onEditAnswer({ standardAnswers: resStandardAnswers.sort() })
              }
            }}
            onClose={() => {
              const resOptions = [...options]
              const resStandardAnswers = [...(standardAnswers || [])]
              resOptions.splice(index, 1)
              if (resStandardAnswers.includes(a)) {
                resStandardAnswers.splice(resStandardAnswers.indexOf(a), 1)
              }
              onEditAnswer({
                options: resOptions,
                standardAnswers: resStandardAnswers,
              })
            }}
          >
            {getLetterByIndex(index)}
          </StyleTag>
        ))}
        <ButtonAdd
          style={{
            height: '28px',
            width: '32px',
            border: '1px dashed #AFBDC7',
          }}
          disabled={limitLevel > 0}
          size="small"
          onClick={() => {
            const newOption = getLetterByIndex(options?.length ?? 0)
            onEditAnswer({ options: [...options, newOption] })
          }}
          type="default"
        />
      </ChoiceAnswerWrapper>
      {rules.map((rule) => {
        if (rule.rule) {
          return <WaringText key={rule.message}>{rule.message}</WaringText>
        }
        return null
      })}
      {/* {noAnswers && !isValidField ? <Tips>{'点击选择正确答案'}</Tips> : null} */}
    </Wrapper>
  )
}

const Wrapper = styled.div``
const Tips = styled.div`
  font-size: 12px;
  line-height: 20px;
  color: ${(props) => props.theme.text._3};
`
const ChoiceAnswerWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`

const StyleTag = styled(Tag)<{ $isStandardAnswer: boolean }>`
  background-color: #fff !important;
  cursor: pointer;
  min-width: 56px;
  text-align: center;
  &&& {
    border-color: ${(props) => props.theme.border.greyNormal};
    padding: 3px 12px;
    font-size: 14px;
    ${(props) =>
      props.$isStandardAnswer
        ? css`
            background-color: ${props.theme.brand._1} !important;
            color: #fff;
            box-sizing: border-box;
            border-color: ${props.theme.brand._1};
          `
        : css`
            color: ${props.theme.text._2};
          `}
    .ant-tag-close-icon {
      color: ${(props) =>
        props.$isStandardAnswer ? '#fff' : props.theme.text._1};
      margin-left: 8px;
    }
  }
`
